export default function messageOnFindCheckedActions(status) {
    let message

    switch (status) {
        case 503:
            message = 'Ops! Ocorreu um problema com a internet e não conseguimos buscar os valores das actions.'
            break
        default:
            message = 'Ops! Algo de estranho ocorreu e não conseguimos buscar os valores das actions.'
    }

    return message
}
